<template>
    <div class="element-editor-main">
        <el-tabs v-if="!isNexTaskConfig" style="height: 100%" :tab-position="tabPosition" v-model="tabName"  @tab-click="handleTabClick" type="border-card">
            <!-- 节点信息 -->
            <el-tab-pane name="first" label="节点信息">
                <NodeInfo :key="loadTimer" :nodeInfo="_taskData.nodeInfo" :taskData="_taskData" :processInstance='processInstance' :element="element" />
            </el-tab-pane>
            <!-- 执行人 -->
            <el-tab-pane name="second" label="执行人">
                <ExecutorEdit :key="loadTimer" :executor='_taskData.executor' :processInstance='processInstance'/>
            </el-tab-pane>
             <!-- 操作按钮 -->
            <el-tab-pane name="third" label="操作按钮">
                <OperateBtns :key="loadTimer" :operationBtns="_taskData.operationBtns" />
            </el-tab-pane>
            <!-- 数据操作 -->
            <el-tab-pane name="fourth" label="数据操作">
                <DataOperateEdit :key="loadTimer" :dataOperate='_taskData.dataOperate' :operateType="_taskData.dataOperate.operateType" @saveConfig="saveConfig" />
            </el-tab-pane>
            <!-- 作业指导书 -->
            <el-tab-pane name="fifth" label="作业指导书">
                <WorkInstruction :key="loadTimer" :wiFileInfo="_taskData.wiFileInfo"  />
            </el-tab-pane>
            <!-- 表单权限 -->
            <el-tab-pane name="sixth" label="表单权限">
                 <FormAuthConfig :key="loadTimer" ref="formAuthConfigRef"  v-if="isShowFormAuthConfig" :taskData="_taskData" :processInstance='processInstance' :dataOperate='_taskData.dataOperate'/>
            </el-tab-pane>
        </el-tabs>
        <ExecutorEdit v-if="isNexTaskConfig" :key="loadTimer" :executor='_taskData.executor' :processInstance='processInstance'/>
    </div>
</template>

<script>
    import NodeInfo from './NodeInfo';
    import DataOperateEdit from './DataOperateEdit';
    import ExecutorEdit from './ExecutorEdit';
    import OperateBtns from './OperateBtns';
    import WorkInstruction from './WorkInstruction';
    import FormAuthConfig from './FormAuthConfig';
    export default {
        components: {
            NodeInfo,
            DataOperateEdit,
            ExecutorEdit,
            OperateBtns,
            WorkInstruction,
            FormAuthConfig
        },
        data () {
            return {
                tabName: 'first',
                tabPosition: 'left',
                isShowFormAuthConfig: 'false',
                loadTimer: ''
            };
        },
        props: {
            isNexTaskConfig: {
                type: Boolean,
                default: false
            },
            taskData: {
                type: Object
            },
            processInstance: {
                type: Object
            }
        },
        created () {
            this.$emit('hideMainSaveBtn', true);
            this.loadTimer = new Date().getTime();
        },
        computed: {
            _taskData () {
                this.tabName = 'first';
                return this.taskData;
            },
            element () {
                return {
                    taskName: this.taskData.taskName
                };
            }
        },
        methods: {
            saveConfig () {
                this.$emit('saveConfig');
            },
            async handleTabClick (tab, event) {
                this.loadTimer = new Date().getTime();
                if (tab.name === 'sixth') {
                    this.isShowFormAuthConfig = true;
                    this.$emit('hideMainSaveBtn', false);
                } else {
                    this.$emit('hideMainSaveBtn', true);
                }
            }
        }
    };
</script>

<style lang="less">
    .element-editor-main {
      margin-top: -25px;
      // height: ~"calc(100% - 7vh)";
      // position: absolute;
      // width: 98%;
      .exec-type {
        .el-radio+.el-radio {
            margin-left: 0;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/ProcessEditor/components/ElementEditor.vue